<template>
  <div id="app">
    <!-- 需要被缓存的路由入口 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要被缓存的路由入口 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

import {setSession, setLocal,UrlSearch } from '@/utils/utils'
import URL from "@/api/api";
export default {
  name: "App",
  data() {
    return {
      appId: "",
      code: "",
      firstTransferPerson: "",
      articleId: "",
      // openId: "o79BZsyhwH-UdEXw2dKiTbSm5w1s",
      openId: ""

    };
  },

  created() {
    if(UrlSearch().phoneNo){
      setLocal('agentPhone',UrlSearch().phoneNo)
    }
    // eslint-disable-next-line no-undef
    // if (window.returnCitySN) {
    //   // eslint-disable-next-line no-undef
    //   setLocal("cip", window.returnCitySN.cip);
    // }
    setLocal('pid', this.getUrlParams("pid"))//团队的分享人信息
    setLocal('cpid', this.getUrlParams("cpid"))//经纪人发展的客户
    if (location.hostname === "zf.dtfcloud.com") {
      this.appId = "wxae0168c583647722";
    } else {
      this.appId = "wxae0168c583647722";
      //  this.appId = "wxae0168c583647722";
    }
    if (this.getUrlParams("firstTransferPerson")) {
      this.firstTransferPerson = this.getUrlParams("firstTransferPerson");
      setSession("firstTransferPerson", this.firstTransferPerson)
    }
    this.articleId = this.getUrlParams("articleId");
    this.code = this.getUrlParams("code"); //获取code
    // 59.80.40.140  183.66.65.237

    this.userid = this.getUrlParams("userid"); //获取code
    if (this.userid) {
      this.getAuthInfo()
    }  else {
      if (sessionStorage.getItem("wechatnumber") || sessionStorage.getItem("openId") || localStorage.getItem("openid")) {
        this.openId = sessionStorage.getItem("wechatnumber") || sessionStorage.getItem("openId") || localStorage.getItem("openid");
        setLocal("wechatnumber", this.openId);
        setSession("openId", this.openId);
      } else {
        if (!this.code) {
          this.goAuthorize();
        } else {
          if (this.openId) {
            return;
          }
          // 致复公众号进来的saas收费页面则不需要授权
          if (UrlSearch().zfsaas) {
            return;
          }
          this.getOpenID();
        }
      }
    }
    // this.openId = "o59kX619xOOzJ2Bwd4YqlY5gjO50";
    // sessionStorage.setItem("openId", "o59kX619xOOzJ2Bwd4YqlY5gjO50");
    // sessionStorage.setItem("unionid", "oP22H5hNvYVvb92xlAnM6e4EcoIs");
    // this.openId = "oKwLcv1xOnCMuc_D_24_FHg3diQA";
    // sessionStorage.setItem("openId", "oKwLcv1xOnCMuc_D_24_FHg3diQA");
  },
  methods: {
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    getAuthInfo() {
      let data = {
        channel: "android",
        userid: this.userid
      };
      this.$fetchGet(URL.getAuthInfo.url, data).then((res) => {
        if (res.data.code === 20000) {
          setLocal("openid", res.data.data.openid);
          setLocal("nickname", res.data.data.nickName);
          setLocal("headimgurl", res.data.data.avatarName);
          setLocal("userid", res.data.data.id);
          setLocal("unionid", res.data.data.unionid)
          setSession("openId", res.data.data.openid);
          setSession("nickname", res.data.data.nickName);
          setSession("headImgUrl", res.data.data.avatarName);
          setSession("unionid", res.data.data.unionid)
          setSession("userid", res.data.data.id)
        }
      });
    },
    goAuthorize() {
      // 非静默授权
      // window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.appId + "&redirect_uri=" + encodeURIComponent(location.href) + "&response_type=code&scope=snsapi_base&state=1&connect_redirect=1#wechat_redirect");
      window.location.replace(
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.appId +
        "&redirect_uri=" +
        encodeURIComponent(location.href) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"
      );
    },
    getTimeStamp: function() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var Milliseconds = now.getMilliseconds();//毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time =  year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec + ":" + Milliseconds;
      return time;
    },
    getOpenID() {
      var that = this;
      var pid1 = localStorage.getItem("pid");
      var cpid = localStorage.getItem("cpid");
      var type = pid1 ? "b" : (cpid ? "c" : "")
      let data = {
        channel: "ZFKJ",
        code: this.code,
        pid: pid1 ? pid1 : (cpid ? cpid : ""),
        type: type
      };
      that.$fetchGet(URL.getUserInfo.url, data).then(res => {
        that.openId = res.data.openid;
        setLocal("openid", res.data.openid);
        setLocal("nickname", res.data.nickname);
        setLocal("headimgurl", res.data.headimgurl);
        setLocal("userid", res.data.id);
        setLocal("unionid", res.data.unionid)
        setSession("openId", res.data.openid);
        setSession("nickname", res.data.nickname);
        setSession("headImgUrl", res.data.headimgurl);
        setSession("unionid", res.data.unionid)
        setSession("userid", res.data.id)
        this.openId = res.data.openId;
        setLocal("wechatnumber", res.data.openid)
        setLocal("cip", res.data.ip);
      })
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif, PingFang SC , Source Han Sans CN;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  background: #F5F5F5;
  /* margin-top: 60px; */
}
</style>
